import { render, staticRenderFns } from "./PrimaryBtn.vue?vue&type=template&id=1108b7f2&scoped=true&"
import script from "./PrimaryBtn.vue?vue&type=script&lang=ts&"
export * from "./PrimaryBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108b7f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
